'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export const useLandingPageTracking = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
};
function _temp() {
  if (process.env.NEXT_PUBLIC_WEB !== "lcv") {
    return;
  }
  const path = window.location.pathname;
  const queryParams = new URLSearchParams(window.location.search);
  if (path === "/interested" || queryParams.get("utm_source")?.toLowerCase() === "line") {
    fetch("/api/firehose/landing-page", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        url: window.location.origin,
        path,
        query_param: queryParams.toString()
      })
    });
  }
}